'use client';

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import CloseButton from 'assets/icons/close-x.svg';
import ChevronL from 'assets/icons/chevron-l.svg';
import styles from './artwork-viewer.module.scss';
import StudentArtworkBasics from 'components/student-artworks/student-artwork-basics';

const StudentArtworkViewer = (props) => {
	const { handleCloseClick, artworks, initialActiveObjectIndex } = props;
	const [activeObjectIndex, setActiveObjectIndex] = useState(
		initialActiveObjectIndex,
	);

	const forwardDisabled = activeObjectIndex === artworks.length - 1;
	const prevDisabled = activeObjectIndex === 0;

	const handleForwardClick = () => {
		setActiveObjectIndex(activeObjectIndex + 1);
	};

	const handlePrevClick = () => {
		setActiveObjectIndex(activeObjectIndex - 1);
	};

	useEffect(() => {
		const handleKeyDown = (e) => {
			e = e || window.event;
			if (e.keyCode == '37') {
				!prevDisabled && setActiveObjectIndex(activeObjectIndex - 1);
			} else if (e.keyCode == '39') {
				!forwardDisabled && setActiveObjectIndex(activeObjectIndex + 1);
			} else if (e.key == 'Escape') {
				handleCloseClick();
			}
		};
		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [prevDisabled, forwardDisabled, activeObjectIndex, handleCloseClick]);

	return (
		<div
			className={`
			${styles.container}
			${styles.isFullscreen}
		`}
		>
			<button className={styles.close} onClick={handleCloseClick}>
				<CloseButton />
			</button>
			<StudentArtworkBasics
				key={artworks[activeObjectIndex]._id}
				artwork={artworks[activeObjectIndex]}
			/>
			<button
				disabled={prevDisabled}
				onClick={handlePrevClick}
				className={`
					${styles.back}
					${styles.arrow}
					${prevDisabled && styles.isDisabled}
				`}
			>
				<ChevronL />
			</button>
			<button
				disabled={forwardDisabled}
				onClick={handleForwardClick}
				className={`
					${styles.forward}
					${styles.arrow}
					${forwardDisabled && styles.isDisabled}
				`}
			>
				<ChevronL />
			</button>
		</div>
	);
};

StudentArtworkViewer.propTypes = {
	handleCloseClick: PropTypes.func,
	initialActiveObjectIndex: PropTypes.any,
	artworks: PropTypes.array,
};

export default StudentArtworkViewer;
